// extracted by mini-css-extract-plugin
module.exports = {"container":"e2","image":"e3","title":"e4","desc":"e5"};